import styled from 'styled-components';
import { ButtonContainer } from './ButtonContainer';

export const TwoButtonContainer = styled(ButtonContainer)`
  & > :nth-child(1) {
  }
`;
